import { Component } from '@angular/core';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { LazyLoadEvent } from 'primeng/api';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonCieModel } from 'src/app/model/common/cie';
import { CIE_10 } from './cie.constants';
import { CieService } from './cie.service';

@Component({
  selector: 'ms-common-cie',
  templateUrl: './cie.component.html',
})
export class CieComponent extends BaseComponent {
  readonly screen = CIE_10;
  protected setScreen = true;
  cie: VonPageResponseModel<CommonCieModel> =
    {} as VonPageResponseModel<CommonCieModel>;
  fileExample: any;
  dtDescription?: string;

  constructor(protected service: CieService) {
    super();
  }

  downloadTemplate = this.service.downloadTemplate;

  onInit = () => {
    this.loading = true;
    this.subscriptions.push(
      this.service.getCieLazyLoad().subscribe((cie) => (this.cie = cie))
    );
  };

  lazyReadCie = ($event: LazyLoadEvent) => {
    this.service.setLoadingState();
    const page = $event.first! / $event.rows!;
    const query = $event.filters!.description
      ? $event.filters!.description.value
      : '';
    this.subscriptions.push(
      this.service.readCie(page, $event.rows!, query).subscribe()
    );
  };
}
